// Official MotoGO logo - transparent PNG.
// Rendered with object-contain so the FULL wordmark is always visible.
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_rider-collective/artifacts/xhsuqhkx_ChatGPT%20Image%20May%2012%2C%202026%2C%2002_53_14%20PM.png";

export const Logo = ({ className = "h-10 w-10" }) => (
  <span
    className={`relative inline-flex items-center justify-center shrink-0 ${className}`}
    aria-label="MotoGO"
  >
    <img
      src={LOGO_URL}
      alt="MotoGO"
      className="relative h-full w-full object-contain"
      style={{ filter: "drop-shadow(0 0 10px rgba(57,255,20,0.4))" }}
      draggable={false}
    />
  </span>
);
